





















































































































import Vue from "vue";
import SubscribeForUpdatesDialog from "../Utilities/SubscribeForUpdatesDialog.vue";
import FactBtn from "../Utilities/FactBtn.vue";

export default Vue.extend({
  name: "FAQDetails",
  data() {
    return {
      showModal: false as boolean
    };
  },
  components: {
    SubscribeForUpdatesDialog,
    FactBtn
  },
  methods: {
    hideModal() {
      this.showModal = false;
    }
  }
});
